<script lang="ts">
    export let errorMsg,
        formData: LookupFormData = {};
    import TextInput from '../components/TextInput.svelte';
    import Modal from '../components/Modal.svelte';
    import Header from '../components/Header.svelte';
    import Footer from '../components/Footer.svelte';
    import { trackPageView } from '../utils/tagging';
    import { loadWebComponents } from '../utils/wcHelper';
    import { validateReservationLookupInfo } from '../utils/validationUtils';

    loadWebComponents().then(() =>
        Promise.all([
            import('@aurodesignsystem/auro-formkit/auro-input'),
            import('@aurodesignsystem/auro-button'),
            import('@aurodesignsystem/auro-alert'),
            import('@aurodesignsystem/auro-header')
        ])
    );

    function triggerFormOnEnter(e: KeyboardEvent) {
        if (e.keyCode === 13) {
            submitForm();
        }
    }

    function submitForm() {
        if (disabled) return;
        submitting = true;
        form.submit();
    }

    let submitting = false;
    let modal;
    let form: HTMLFormElement;
    $: disabled = !validateReservationLookupInfo(
        formData.confirmationCode,
        formData.lastName
    );

    interface LookupFormData {
        confirmationCode?: string;
        lastName?: string;
    }

    function tealiumTracking() {
        trackPageView({
            page_name: 'booking : reservation-lookup',
            channel: 'booking'
        });
    }

    tealiumTracking();
</script>

<Header />
<main>
    {#if errorMsg}
        <auro-alert type="error" class="util_marginTop--md">{errorMsg}</auro-alert>
    {/if}
    <auro-header level="1" display="800">View new flight</auro-header>
    <p>
        Start here to view and check in to your new flight. We'll get you on
        your way as soon as possible.
    </p>
    <form
        bind:this={form}
        action="/disruptions/start"
        method="post"
        on:keyup={triggerFormOnEnter}
    >  
        <TextInput
            inputLabel="Passenger's last name"
            bind:inputValue={formData.lastName}
            inputName="lastName"
            testId="lastNameInput"
            cssClass="util_marginBottom--md"
        />
        <TextInput
            inputLabel="Confirmation code"
            bind:inputValue={formData.confirmationCode}
            inputName="confirmationCode"
            testId="confirmationCodeInput"
            cssClass="util_marginBottom--xs"
        />

        <button class="link-button" on:click={modal.open()} type="button">
            What's this?
        </button>

        <auro-button
            onclick={submitForm}
            disabled={disabled || submitting || undefined}
        >
            {#if submitting}Submitting...{:else}Continue{/if}
        </auro-button>

        <!-- Announces form submit to screen readers -->
        <p role="status" class="util_displayHiddenVisually">
            {#if submitting}Submitting{/if}
        </p>

        <Modal bind:this={modal}>
            <auro-header level="2" display="400">
                Confirmation code
            </auro-header>
            <div>
                <p>
                    Your confirmation code is
                    <b>6 letters.</b>
                    Use your confirmation code to find an active reservation. Example:
                    <b>ABCDEF</b>
                </p>
            </div>
        </Modal>
    </form>
</main>

<Footer />

<style lang="scss">
    auro-button {
        margin-top: var(--ds-grid-margin-xl);
        display: block;
    }
</style>
